import { Link } from "react-router-dom";
import visa from "../../assets/payments/visa.svg";
import mastercard from "../../assets/payments/mastercard.svg";
import klarna from "../../assets/payments/klarna.svg";
import paypal from "../../assets/payments/paypal.svg";
import applepay from "../../assets/payments/applepay.svg";
import googlepay from "../../assets/payments/googlepay.svg";

const Footer = () => (
  <footer className="footer">
    <div className="content-padding">
      <div className="footer-columns flex-row gap-xl">
        <div className="footer-col flex-col">
          <h4>SHOP</h4>
          <ul>
            <li>
              <Link to="/shop">All products</Link>
            </li>
            <li>
              <Link to="/shop?section=tshirts">T-Shirts</Link>
            </li>
            <li>
              <Link to="/shop?section=jumpers">Jumpers</Link>
            </li>
            <li>
              <Link to="/shop?section=hats">Hats</Link>
            </li>
          </ul>
        </div>
        <div className="footer-col flex-col">
          <h4>ABOUT</h4>
          <ul>
            <li>
              <Link to="/about">Our Story</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/faq">FAQ</Link>
            </li>
          </ul>
        </div>
        <div className="footer-col flex-col">
          <h4>INFO</h4>
          <ul>
            <li>
              <Link to="/shipping">Shipping</Link>
            </li>
            <li>
              <Link to="/returns">Returns</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms">Terms</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-copyright flex-center">
        <p>Accepted Payment Methods</p>
      </div>
      <div
        className="footer-payments flex-center"
        style={{ margin: "0.5rem 0 1rem 0" }}
      >
        <img
          src={visa}
          alt="Visa"
          style={{ height: "36px", margin: "0 8px" }}
        />
        <img
          src={mastercard}
          alt="Mastercard"
          style={{ height: "36px", margin: "0 8px" }}
        />
        <img
          src={klarna}
          alt="Klarna"
          style={{ height: "36px", margin: "0 8px" }}
        />
        <img
          src={paypal}
          alt="PayPal"
          style={{ height: "36px", margin: "0 8px" }}
        />
        <img
          src={applepay}
          alt="Apple Pay"
          style={{ height: "36px", margin: "0 8px" }}
        />
        <img
          src={googlepay}
          alt="Google Pay"
          style={{ height: "36px", margin: "0 8px" }}
        />
      </div>
      <div className="footer-copyright flex-center">
        <p>@2026 Solo Pints. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
